'use client';

import { SessionProviderWrapper } from "@/contexts/SessionProviderWrapper";
import { SessionProvider } from "next-auth/react";

export default function AuthProvider({
  children,
  session,
}: {
  children: React.ReactNode;
  session: any;
}): React.ReactNode {
  return <SessionProvider session={session}><SessionProviderWrapper > {children} </SessionProviderWrapper></SessionProvider>;
}
